import styles from "~/pages/blog/blog-index.module.scss";
import ArticleCard from "~/components/Blog/ArticleCard";
import Layout from "~/components/layouts/Blog";
import Head from "~/components/Meta/Head";
import {
  getFeaturedPosts,
  getPosts,
  getPost,
  formatBlogPosts,
} from "~/utils/Blog/Post";
import { getTag } from "~/utils/Blog/Tag";
import { getPage } from "~/utils/Blog/Page";
import { FetchError } from "~/utils/Fetch/json";
import { blog as blogConfig } from "~/config/blog";
import Article from "~/components/Blog/Article";
import Tags from "~/components/Blog/Tags";
import Author from "~/components/Blog/Author";

import { NON_PRIME_FILTERS } from "~/config/blog";

import API from "~/config/api";

import CTA from "~/components/Common/CTA";
import { BLOG_FUNNEL } from "~/config/funnel";
import Blog from "@referralexchange/rea-ui-react/src/components/blocks/Blog";

const SinglePost = ({
  featured,
  post,
  tag,
  blog_posts,
  meta_title,
  canonicalUrl,
}) => {
  return (
    <>
      <Head
        title={meta_title}
        description={post?.meta_description}
        socialImageUrl={post?.og_image || post?.twitter_image}
        url={canonicalUrl}
        breadcrumbJson={{
          "@context": "https://schema.org",
          "@type": "Article",
          headline: post.title,
          url: canonicalUrl,
          datePublished: post.published_at,
          dateModified: post.updated_at,
          keywords:
            post.tags &&
            post.tags
              .filter((tag) => tag.visibility == "public")
              .map((tag) => {
                return tag.name;
              })
              .join(", "),
          description: post?.meta_description,
          mainEntityOfPage: canonicalUrl,
          publisher: {
            "@type": "Organization",
            name: "RealEstateAgents.com",
            url: "https://www.realestateagents.com/",
            logo: {
              "@type": "ImageObject",
              url:
                "https://www.realestateagents.com/static/images/logos/rea-icon-color.2x.min.png",
            },
          },
          author: {
            "@type": "Person",
            name: post?.primary_author?.name,
            url: post?.primary_author?.url,
            image: {
              "@type": "ImageObject",
              url: post?.primary_author?.profile_image,
            },
          },
          image: {
            "@type": "ImageObject",
            url: post?.feature_image,
          },
        }}
      />
      {post.codeinjection_head && (
        <div dangerouslySetInnerHTML={{ __html: post.codeinjection_head }} />
      )}
      <div className={styles["blog-index"]}>
        <div className={styles["blog-index__container"]}>
          <main className={styles["blog-index__single"]}>
            <Article post={post} />
            {post.tags && <Tags post={post} />}
            {post.primary_author && <Author post={post} />}
          </main>
          <aside className={styles["blog-index__sidebar"]}>
            <div className={styles["blog-index__sidebar-container"]}>
              <div className={styles["blog-index__cta-container"]}>
                <CTA page={"blog"} funnel={BLOG_FUNNEL} />
              </div>
              <div className={styles["blog-index__sidebar-heading"]}>
                Featured Blog Posts
              </div>
              {featured.posts.map((post, key) => {
                return <ArticleCard minimal={true} post={post} key={key} />;
              })}
            </div>
          </aside>
        </div>
        {blog_posts && blog_posts.length > 0 && (
          <div className={styles["blog-index__more-posts-container"]}>
            <Blog
              title={`More Resources`}
              posts={blog_posts}
              button={{
                label: "View More",
                href: `${blogConfig.baseUrl}/${tag ? tag.slug : ""}`,
              }}
            />
          </div>
        )}
      </div>
      {post.codeinjection_foot && (
        <div dangerouslySetInnerHTML={{ __html: post.codeinjection_foot }} />
      )}
    </>
  );
};

SinglePost.getLayout = function getLayout(page) {
  return <Layout {...page.props}>{page}</Layout>;
};

export const getServerSideProps = async (ctx) => {
  try {
    const [post_res, featured_res, posts_res] = await Promise.all([
      getPost({ slug: "real-estate-guide-for-buyers" }),
      getFeaturedPosts({}),
      getPosts({ tag: "real-estate-guide-for-buyers", pageLimit: 6 }),
      // getTag({slug: "real-estate-guide-for-buyers"}),
    ]);
    const [post, featured, ghost] = await Promise.all([
      post_res.data.posts[0],
      featured_res.data,
      posts_res.data,
      // tag_res.data
    ]);

    const blog_posts = formatBlogPosts(ghost.posts);

    return {
      props: {
        featured,
        post,
        blog_posts,
        // tag,
        meta_title: post.meta_title,
        canonicalUrl: `${process.env.CLIENT_ORIGIN}/blog/real-estate-guide-for-buyers`,
      },
    };
  } catch {
    return {
      props: { statusCode: 404 },
      notFound: true,
    };
  }
};

export default SinglePost;
